<ng-container *ngIf="placementsList$ | async as placements">
    <jobs-placements-list-of-placements [placements]="placements" (selectPlacement)="select($event)">
    </jobs-placements-list-of-placements>
</ng-container>